module.exports = __webpack_public_path__ + "img/other_iQOO3.5040b839.jpg";